import React from "react";

interface Props {
	children?: React.ReactNode;
}

function Workbench({ children }: Props) {
	return (
		<div className="workbench" id="workbench">
			{children}
		</div>
	);
}

export default Workbench;
